import Track from "@shared/modules/analytics/components/Track/Track.web";
import { postMessageToReactNativeWebView } from "@shared/utils/webview";
import Button from "@ui-kit/form/Button/Button.web";
import { useTranslation } from "@shared/utils/internationalization";
import { Login } from "@shared/modules/login/components";
import { LoginSharedProps } from "@shared/modules/login/components/Login/Login.props";
import WebviewComponentAdaptor from "@shared/components/application/other/WebviewComponentAdaptor/WebviewComponentAdaptor.web";

export default function CheckoutLoginContent(
  props: LoginSharedProps
): JSX.Element {
  return (
    <WebviewComponentAdaptor
      webComponent={<CheckoutLoginContent.WebComponent {...props} />}
      webviewComponent={<CheckoutLoginContent.WebviewComponent />}
    />
  );
}

CheckoutLoginContent.WebviewComponent = function WebviewComponent() {
  const { t } = useTranslation("common");

  const postLoginMessage = () =>
    postMessageToReactNativeWebView({ action: "LOGIN" });

  return (
    <Track.Click analytics={{ label: "showpass-login-button" }}>
      <Button
        variant="solid"
        maxW="sm"
        w="100%"
        h="element.4xl"
        mt="md"
        onClick={postLoginMessage}
        data-testid="log-in-button"
      >
        {t("Log in")}
      </Button>
    </Track.Click>
  );
};

CheckoutLoginContent.WebComponent = function WebComponent({
  onSignupClick,
  onForgotPasswordClick,
  onSuccess,
}: LoginSharedProps) {
  return (
    <Login
      onSignupClick={onSignupClick}
      onForgotPasswordClick={onForgotPasswordClick}
      onSuccess={onSuccess}
    />
  );
};
